// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForecastHeader_headerWrapper__fL9Ng {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  padding: 20px 4px 10px 4px;
  background: transparent;
  position: relative;
  margin-bottom: 40px;
}

.ForecastHeader_characteristicsBlock__HOju5 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  min-width: unset;
}

.ForecastHeader_characteristic__EkuZc {
  display: flex;
  align-items: center;
  min-width: 60px;
  padding: 8px 10px;
  flex-direction: column;
  background: rgba(90, 65, 125, 0.359);
  border-radius: 12px;
}

.ForecastHeader_label__YL0yh {
  color: #ae94e2;
  font-size: 9px;
  font-weight: 400;
  margin-bottom: 2px;
  letter-spacing: 0.2px;
}

.ForecastHeader_value__NIiyu {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.ForecastHeader_block__g5VpV {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ForecastHeader_avatarBlock__LXaXj {
  min-width: unset;
  border-radius: 50%;
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #6a5bc9 0%, #ce7fe0 100%);
  box-shadow: 0 8px 32px 0 rgba(99, 72, 156, 0.25);
  border: 3px solid #7e66a8;
}

.ForecastHeader_avatar__hrdQ4 {
  width: 170px;
  height: 170px;
  object-fit: contain;
  margin-bottom: 10px;
}

.ForecastHeader_ctaButton__4o3yv {
  padding: 8px 18px;
  font-size: 14px;
  border-radius: 13px;
  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);
  color: #fff;
  font-weight: 600;
  border: none;
  box-shadow: 0 2px 10px 0 rgba(120, 98, 190, 0.12);
  transition: background 0.2s;
  cursor: pointer;
}

.ForecastHeader_ctaButton__4o3yv:hover,
.ForecastHeader_ctaButton__4o3yv:focus {
  background: linear-gradient(93deg, #977dff 0%, #caa2ff 100%);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Forecast/ForecastHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iDAAiD;EACjD,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,4DAA4D;AAC9D","sourcesContent":[".headerWrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px;\n  padding: 20px 4px 10px 4px;\n  background: transparent;\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.characteristicsBlock {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: center;\n  min-width: unset;\n}\n\n.characteristic {\n  display: flex;\n  align-items: center;\n  min-width: 60px;\n  padding: 8px 10px;\n  flex-direction: column;\n  background: rgba(90, 65, 125, 0.359);\n  border-radius: 12px;\n}\n\n.label {\n  color: #ae94e2;\n  font-size: 9px;\n  font-weight: 400;\n  margin-bottom: 2px;\n  letter-spacing: 0.2px;\n}\n\n.value {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.avatarBlock {\n  min-width: unset;\n  border-radius: 50%;\n  width: 180px;\n  height: 180px;\n  background: linear-gradient(135deg, #6a5bc9 0%, #ce7fe0 100%);\n  box-shadow: 0 8px 32px 0 rgba(99, 72, 156, 0.25);\n  border: 3px solid #7e66a8;\n}\n\n.avatar {\n  width: 170px;\n  height: 170px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.ctaButton {\n  padding: 8px 18px;\n  font-size: 14px;\n  border-radius: 13px;\n  background: linear-gradient(93deg, #795cff 0%, #ad7cff 100%);\n  color: #fff;\n  font-weight: 600;\n  border: none;\n  box-shadow: 0 2px 10px 0 rgba(120, 98, 190, 0.12);\n  transition: background 0.2s;\n  cursor: pointer;\n}\n\n.ctaButton:hover,\n.ctaButton:focus {\n  background: linear-gradient(93deg, #977dff 0%, #caa2ff 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrapper": `ForecastHeader_headerWrapper__fL9Ng`,
	"characteristicsBlock": `ForecastHeader_characteristicsBlock__HOju5`,
	"characteristic": `ForecastHeader_characteristic__EkuZc`,
	"label": `ForecastHeader_label__YL0yh`,
	"value": `ForecastHeader_value__NIiyu`,
	"block": `ForecastHeader_block__g5VpV`,
	"avatarBlock": `ForecastHeader_avatarBlock__LXaXj`,
	"avatar": `ForecastHeader_avatar__hrdQ4`,
	"ctaButton": `ForecastHeader_ctaButton__4o3yv`
};
export default ___CSS_LOADER_EXPORT___;
